













import { Component, Vue, Model } from 'vue-property-decorator';
import { emptyText } from '@/utils/constants';
import { dateTypeItems } from '../render';
import { ITimeType } from '../types';

// 小组件的时间段下拉框
@Component
export default class HomeWidgetTimeSelect extends Vue {
  @Model('modelChange') public modelValue!: ITimeType;

  public emptyText = emptyText;

  public get value() {
    return this.modelValue || '';
  }

  public set value(value: ITimeType) {
    this.$emit('modelChange', value);
  }

  public get items() {
    return dateTypeItems.filter((item) => !item.hide);
  }
}
